<template>
  <BlockWrapper class="how-it-work" small id="how-it-work">
    <bim-text type=h5 bold class="text-center how-it-work__title">Как это работает?</bim-text>
    <bim-row class="steps__wrapper" justify="center">
      <bim-col
        cols=12
        md=3
        v-for="(step, index) of steps"
        :key="index"
        class="step d-flex flex-column mb-12 mb-sm-0"
      >
        <div class="flex-grow-1 step-top">
          <img :src="step.img" alt="" :style="{ margin: step.imgPadding }" />
          <bim-text type=hint bold class="step__count primary-color mb-3">{{ index + 1 }} шаг</bim-text>
          <bim-text type=main bold class="step__title" v-html="step.title"></bim-text>
        </div>
        <bim-text type=medium v-html="step.desc" class="step-bottom"></bim-text>
      </bim-col>
    </bim-row>
  </BlockWrapper>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import bimContainer from '@bimlib/components/bimContainer'

export default {
  name: "block",
  components: {
    bimCol,
    bimRow,
    bimContainer,
  },
  inject: ['getImgPath'],
  computed: {
    steps() {
      return [
        {
          img: this.getImgPath('img-special-landing-cash-4.svg'),
          imgPadding: '0 0 23px 0',
          title: "Подписываете агентский договор",
          desc: "Мы сами его напишем и пришлем, <b>в офис ехать не нужно.</b>",
        },
        {
          img: this.getImgPath('img-special-landing-cash-5.svg'),
          imgPadding: '0 0 27px 0',
          title: "Передаете нам контактные данные",
          desc: "Адреса почты и телефона с именем будет достаточно, чтобы мы могли сами связаться с клиентом.",
        },
        {
          img: this.getImgPath('img-special-landing-cash-6.svg'),
          imgPadding: '0 0 22px 0',
          title: "Ждете несколько дней",
          desc: "В это время наши менеджеры продадут услугу приглашенному клиенту.",
        },
        {
          img: this.getImgPath('img-special-landing-cash-7.svg'),
          imgPadding: '0 0 26px 0',
          title: "Получаете деньги",
          desc: "Оплата согласно агентскому договору. Точно и в срок.",
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.how-it-work {
  background: #f7f7f7;
  padding: 80px 0 90px;
  .how-it-work__title {
    margin-bottom: 84px;
  }
}
.steps__wrapper {
  .step {
    padding: 0 15px;
    .step__title {
      font-size: 20px;
      line-height: 1.3;
    }
    .step__count {
      letter-spacing: 1px;
      text-transform: uppercase;
    }
    .step-top {
      flex: 0 0 166px;
    }
    .step-bottom {
      line-height: 1.57;
      letter-spacing: 0.2px;
    }
    ::v-deep .step__link {
      border-bottom: 1px solid $primary-color;

      &:hover {
        opacity: .8;
      }
    }
  }
}
</style>
